import { useMemo } from 'react';

import { useAppSelector } from 'shared/lib';

import { getAnalyticsSearchOutput } from 'entities/analytics';
import {
  hasAllRefusedMplOffers,
  hasApprovedMplOffers,
  hasMplOffers,
  hasMplPreApprovalOffers,
  selectHasLeadgenGroup,
} from 'entities/scenario';

export const useAnalyticsSearchOutput = () => {
  const hasMplPreApproval = useAppSelector(hasMplPreApprovalOffers);
  const hasLeadGen = useAppSelector(selectHasLeadgenGroup);
  const isAvailableMpl = useAppSelector(hasMplOffers);
  const hasApprovedMpl = useAppSelector(hasApprovedMplOffers);
  const isAllRefusedMpl = useAppSelector(hasAllRefusedMplOffers);

  return useMemo(
    () => getAnalyticsSearchOutput({ hasMplPreApproval, hasLeadGen, isAvailableMpl, hasApprovedMpl, isAllRefusedMpl }),
    [hasMplPreApproval, hasLeadGen, isAvailableMpl, hasApprovedMpl, isAllRefusedMpl],
  );
};
